import React from "react";
import { Box, Button, Flex, HStack, Image, Text } from "@chakra-ui/react";
import { useBizflexAppUrls } from "../../../utils/useBizflexAppUrls";

const ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.fastamoniorg.bizflex";
const IOS_APP_URL =
  "https://apps.apple.com/us/app/bizflex-africa/id6754340965";

const RewardsHero = () => {
  const { registerFromRewardsUrl } = useBizflexAppUrls();
  return (
    <Box
      color="#fff"
      fontFamily="Nohemi, system-ui, sans-serif"
      w="full"
      mt={{ base: "36px", md: "70px" }}
      pb={{ base: "32px", md: "80px" }}
      pos="relative"
      zIndex={2}
      mx="0px"
      px="0px"
    >
      <Flex
        direction="column"
        align="center"
        textAlign="center"
        w="full"
        maxW="980px"
        mx={{ base: "auto", sm: "none", md: "auto" }}
        px={{ base: "4px", sm: "4px", md: "0" }}
      >
        <Box
          as="h1"
          textAlign="center"
          fontSize={{ base: "24px", sm: "28px", md: "44px", lg: "46px" }}
          fontWeight={600}
          fontFamily="Poppins"
          lineHeight={{ base: "1.2", md: "1.12" }}
          letterSpacing={{ base: "0.02em", md: "0.04em" }}
          textTransform="uppercase"
          color="#FFFFFF"
          w="100%"
          maxW="100%"
          overflow="visible"
        >
          <Text
            as="span"
            display="block"
            whiteSpace="normal"
            wordBreak="break-word"
          >
            FLEX MORE.{" "}
            <Text as="span" color="#FF9D16">
              EARN ₦3,000+
            </Text>
            {" "}
            <Image
              src="/assets/Glovo.svg"
              alt="Glovo"
              display="inline-block"
              verticalAlign="baseline"
              h={{base: "1.2em", sm: "1.4em", md: "1.2em"}}
              w="auto"
              mx="0px"
              transform="translateY(0.08em)"
            />
            {" "}
            PRIME
          </Text>
        </Box>

        <Box
          mt={{ base: "16px", md: "20px" }}
          maxW="720px"
          // mx="auto"
          textAlign="center"
          whiteSpace={{ base: "pre-line", md: "normal" }}
          color="#FFFFFF"
          fontSize={{ base: "18px", sm: "18px", md: "18px" }}
          lineHeight={{ base: "20px", md: "26px" }}
          fontWeight={400}
          fontFamily="Poppins"
        >
          <Text as="p" m={0}>
            Use BizFlex like you normally do, earn points, and unlock rewards.
          </Text>
          <Text as="p" m={0} mt={{ base: "6px", md: "8px" }}>
            Coming from Glovo? Enter{" "}
            <Text
              as="span"
              display="inline-block"
              verticalAlign="middle"
              bg="#FF9D16"
              color="#000000"
              fontWeight={600}
              fontSize="0.92em"
              lineHeight="1.2"
              px={{ base: "6px", md: "8px" }}
              py="6px"
              borderRadius="6px"
              mx="2px"
            >
              GLOVO
            </Text>{" "}
            in the referral field to unlock rewards
          </Text>
        </Box>

        <Flex
          mt={{ base: "24px", md: "32px" }}
          direction="row"
          flexWrap={{ base: "nowrap", md: "wrap" }}
          justifyContent="center"
          align="center"
          gap={{ base: "6px", sm: "8px", md: "12px" }}
          w="100%"
          maxW="100%"
        >
          <Button
            as="a"
            href={registerFromRewardsUrl}
            target="_blank"
            rel="noreferrer"
            bg="#FFFFFF"
            color="#000000"
            borderRadius="12px"
            px={{ base: "12px", sm: "14px", md: "20px" }}
            h={{ base: "48px", md: "44px" }}
            minW={{ base: "124px", md: 0 }}
            flexShrink={1}
            fontWeight={400}
            fontFamily="Poppins"
            fontSize={{ base: "11px", sm: "12px", md: "15px" }}
            whiteSpace="nowrap"
            iconSpacing="4px"
            _hover={{ bg: "#f3f4f6" }}
            rightIcon={
              <Image
                src="/assets/arroow-right.svg"
                alt=""
                w={{ base: "14px", md: "17px" }}
                h={{ base: "14px", md: "17px" }}
                objectFit="contain"
                ml="0"
                flexShrink={0}
              />
            }
          >
            Start Earning Points
          </Button>

          <Button
            as="a"
            href={ANDROID_APP_URL}
            target="_blank"
            rel="noreferrer"
            bg="rgba(15, 23, 43, 0.72)"
            color="#fff"
            border="1px solid rgba(255, 255, 255, 0.45)"
            borderRadius="12px"
            h={{ base: "48px", md: "44px" }}
            px={{ base: "14px", sm: "10px", md: "12px" }}
            py="0"
            minW={{ base: "92px", md: 0 }}
            flexShrink={0}
            iconSpacing="4px"
            fontWeight={400}
            fontSize={{ base: "11px", sm: "12px", md: "13px" }}
            whiteSpace="nowrap"
            leftIcon={
              <Image
                src="/assets/android.svg"
                w={{ base: "16px", md: "18px" }}
                h={{ base: "12px", md: "13px" }}
                alt="android"
                flexShrink={0}
              />
            }
            _hover={{ bg: "rgba(15, 23, 43, 0.85)" }}
          >
            Android
          </Button>

          <Button
            as="a"
            href={IOS_APP_URL}
            target="_blank"
            rel="noreferrer"
            bg="rgba(15, 23, 43, 0.72)"
            color="#fff"
            border="1px solid rgba(255, 255, 255, 0.45)"
            borderRadius="12px"
            h={{ base: "48px", md: "44px" }}
            px={{ base: "12px", sm: "0px", md: "12px" }}
            py="0"
            minW={{ base: "80px", sm: "78px", md: 0 }}
            flexShrink={0}
            iconSpacing="4px"
            fontWeight={400}
            fontSize={{ base: "11px", sm: "12px", md: "13px" }}
            whiteSpace="nowrap"
            justifyContent="center"
            leftIcon={
              <Image
                src="/assets/apple.svg"
                w={{ base: "16px", md: "18px" }}
                h={{ base: "12px", md: "13px" }}
                alt="apple"
                flexShrink={0}
              />
            }
            sx={{
              ".chakra-button__icon": {
                marginInlineEnd: "4px",
              },
            }}
            _hover={{ bg: "rgba(15, 23, 43, 0.85)" }}
          >
            iOS
          </Button>
        </Flex>

        <Flex
          mt={{ base: "28px", md: "36px" }}
          direction="column"
          align="center"
          gap={{ base: "14px", md: "16px" }}
          w="100%"
        >
          <HStack spacing="0px" justify="center">
            <Image
              src="/assets/people.svg"
              alt="people"
              w={{ base: "100px", md: "100px" }}
              h={{ base: "28px", md: "28px" }}
              objectFit="contain"
            />
            <Text
              color="#FFFFFF"
              fontSize={{ base: "13px", md: "15px" }}
              fontWeight={500}
              fontFamily="Plus Jakarta Sans"
              whiteSpace={{ base: "normal", sm: "nowrap" }}
              textAlign="left"
            >
              +25K Joined the reward program
            </Text>
          </HStack>
        </Flex>
      </Flex>
    </Box>
  );
};

export default RewardsHero;
